// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".NewLine-cls1___752eb4149a4042a1620{/*!*/}.NewLine-cls2__f891788c9a5907e047a6{display:block;clear:both}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cls1": "NewLine-cls1___752eb4149a4042a1620",
	"cls2": "NewLine-cls2__f891788c9a5907e047a6 NewLine-cls1___752eb4149a4042a1620"
};
export default ___CSS_LOADER_EXPORT___;
